import React, { useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import DataTableHelper from "../../../helpers/tables/DataTableHelper";
import Columns from "./Columns";
import { resourcesReports } from "../../../helpers/backend_helper";
import { getPolicyUser } from "../../../helpers/api_helper";
import { Container, Row } from "reactstrap";
import PreviewPDF from "../../../helpers/previewPDF";
import { getStorageCompany, getStorageUser } from "../../../helpers/api_helper";
import Select from "react-select";

const InstallationReport = () => {
  let timeElapsed = new Date();
  let dateNow = `${timeElapsed.getFullYear()}-${
    timeElapsed.getMonth() + 1 < 10 ? "0" : ""
  }${timeElapsed.getMonth() + 1}-${
    timeElapsed.getDate() < 10 ? "0" : ""
  }${timeElapsed.getDate()}`;
  let temp = new Date(timeElapsed);
  let ant = 7 * -86399.9; //dias en segundos
  let finalDate = new Date(temp.setSeconds(ant));
  let dateNowFormat = `${finalDate.getFullYear()}-${
    finalDate.getMonth() + 1 < 10 ? "0" : ""
  }${finalDate.getMonth() + 1}-${
    finalDate.getDate() < 10 ? "0" : ""
  }${finalDate.getDate()}`;
  //const [date, setDate] = useState({initDate:'',endDate:''});
  const [date, setDate] = useState({ initDate: dateNow, endDate: dateNow });
  const [pending, setPending] = useState(false);
  const [fechas, setFechas] = useState([]);
  const [modal, setModal] = useState({ show: false, update: false });
  const [dataPag, setDataPag] = useState({ total: 0 });
  const [filters, setFilters] = useState({
    page: 1,
    perPage: 20,
    search: "",
    orderBy: "id",
    order: "asc",
    initDate: dateNowFormat,
    endDate: dateNow,
  });
  const filtersOperators = { select: true };
  const [items, setItems] = useState([]);
  console.log(dateNowFormat);
  const dispatch = useDispatch();
  useEffect(() => {
    let params = { params: filters };
    setPending(true);
    resourcesReports("show", params, "installationsReport").then((response) => {
      setItems(response.data.data);
      setFechas(response.dates);
      let meta = {
        current_page: response.data.current_page,
        from: response.data.from,
        last_page: response.data.last_page,
        links: response.data.links,
        path: response.data.path,
        per_page: response.data.per_page,
        to: response.data.to,
        total: response.data.total,
      };
      setDataPag(meta);
      setPending(false);
    });
  }, [filters]);

  const getReports = (type) => {
    setPending(true);
    let config = {
      params: filters,
      headers: {
        Accept:
          type == 2
            ? "application/pdf"
            : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      },
      responseType: "blob",
    };

    resourcesReports("show", config, "installationsReport").then((response) => {
      if (type == 1) {
        console.log(response);
        const url = URL.createObjectURL(new Blob([response]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Reporte de Excesos.xlsx");
        document.body.appendChild(link);
        link.click();
        setPending(false);
      } else {
        let nombre = "Archivo";
        var reader = new FileReader();
        reader.readAsDataURL(response);
        reader.fileName = nombre[1] || nombre[0];
        reader.onloadend = function (name) {
          name = nombre[0];
          var base64data = reader.result;
          setPending(false);
          setModal({ show: true, update: false, url: base64data });
        };
      }
    });
  };

  const columns = Columns(fechas);
  document.title = "Instalaciones|Reportes";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="col-12">
            <DataTableHelper
              tittle="Reporte de Instalaciones"
              columns={columns}
              items={items}
              pending={pending}
              config={dataPag}
              filters={filters}
              search={false}
              setFilters={setFilters}
            >
              <Row>
                <div className="col-sm-2 ms-auto float-end">
                  <div className="order-3 float-end">
                    <button
                      className="btn btn-sm btn-success"
                      onClick={() => getReports(1)}
                    >
                      <i className="fa fa-file-excel"></i> Excel
                    </button>
                  </div>
                  <div className="me-2 order-4 float-end">
                    <button
                      className="btn btn-sm btn-danger"
                      onClick={() => getReports(2)}
                    >
                      <i className="fa fa-file-pdf"></i> PDF
                    </button>
                  </div>
                </div>
              </Row>

              <div className="col-md-3">
                <label className="form-label">Fecha Inicial:</label>
                <div className="input-group">
                  <input
                    type="date"
                    className="form-control"
                    placeholder="Fecha"
                    aria-label="Recipient's username"
                    aria-describedby="basic-addon2"
                    value={filters.initDate}
                    onChange={(e) =>
                      setFilters({ ...filters, initDate: e.target.value })
                    }
                  />
                </div>
              </div>
              <div className="col-md-3">
                <label className="form-label">Fecha Final:</label>
                <div className="input-group">
                  <input
                    type="date"
                    className="form-control"
                    placeholder="Fecha"
                    aria-label="Recipient's username"
                    aria-describedby="basic-addon2"
                    value={filters.endDate}
                    onChange={(e) =>
                      setFilters({ ...filters, endDate: e.target.value })
                    }
                  />
                </div>
              </div>
            </DataTableHelper>
          </div>
        </Container>
        {modal.show && <PreviewPDF modalPdf={modal} setModalPdf={setModal} />}
      </div>
    </React.Fragment>
  );
};

export default InstallationReport;
